import { render } from "./RecaptchaField.vue?vue&type=template&id=6dc8a27c&scoped=true&ts=true"
import script from "./RecaptchaField.vue?vue&type=script&lang=ts"
export * from "./RecaptchaField.vue?vue&type=script&lang=ts"

import "./RecaptchaField.vue?vue&type=style&index=0&id=6dc8a27c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc8a27c"]])

export default __exports__